import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebSelectSentenceBox({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [availableChoices, setAvailableChoices] = useState(data.choices);
    const [answer, setAnswer] = useState(data.initialState);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAvailableChoices(data.choices);
        setAnswer(data.initialState);
    }, [question,
        data.choices,
        data.initialState,
    ]);

    const handleChoiceClick = (choice, key) => {
        let ans = {...answer};
        let value = choice.stateKey ?? choice.value; 

        if (ans[key].indexOf(value) > -1) {
            removeChoice(value, key);
        } else {
            ans[key].push(value);

            setAnswer(ans);
            checkCanProceed(ans);
        }
    }

    const checkCanProceed = (ans) => {
        const answerKeys = Object.keys(answer);

        let canProceed = false;
        let finalAnswer = [];
        answerKeys.map((keys) => {
            let answerData = ans[keys];
            if (answerData.length > 0) {
                canProceed = true;
            }

            // loop the answer via keys
            answerData.map((value, index) => {
                // replace here the first_, second_, so and so forth, since we can have same in the sentence
                finalAnswer.push(value.replace("first_", "").replace("second_", "").replace("third_", ""));
                return null;
            });
            
            return null;
        });

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    const removeChoice = (value, key) => {
        let newAnswer = {...answer};
        let index = newAnswer[key].indexOf(value)
        if (index !== -1) {
            newAnswer[key].splice(index, 1);
            setAnswer(newAnswer);
        }
        checkCanProceed(newAnswer);
    }

    return (
        <Box
            sx={{
                width: "1000px",
                fontSize: "30px",
                textAlign: "left",
                padding: "8px",
            }}
        >
            {/* For Sentence */}
            {availableChoices.map((choice, index) => (
                <Box key={index} 
                    sx={{
                    display: "flex",
                    fontSize: "30px",
                    textAlign: "left"
                }}>
                    {/* For Letter */}
                    <Box component="span"
                        sx={{
                            marginRight: "10px",
                            fontSize: "30px",
                            textAlign: "left"
                        }}
                    >{choice.option.value}</Box>
                    
                    {/* For Sentence Creation */}
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: "column",
                        width: "1000px",
                        fontSize: "30px",
                        textAlign: "left",
                        // fontWeight: "500",
                    }}>
                        <Box sx={{
                            position: "relative",
                            width: "100%",
                            fontSize: "30px",
                            textAlign: "left"
                        }}>
                            <Box sx={{
                                boxSizing: "border-box",
                            }}>
                                {choice.option.children.map((option, optionIndex) => {
                                    const Tag = option.type;
                                    return (
                                        <React.Fragment key={optionIndex}>
                                            <Tag style={{
                                                float: "left",
                                                fill: answer[choice.option.stateKey].includes(option.stateKey ?? option.value) ? "rgba(255, 217, 102, 0.75)" : "transparent",
                                                stoke: answer[choice.option.stateKey].includes(option.stateKey ?? option.value) ? "rgb(255, 192, 0)" : "none",
                                                strokeWidth: "0px",
                                                backgroundColor: answer[choice.option.stateKey].includes(option.stateKey ?? option.value) ? "rgba(255, 217, 102, 0.75)" : "transparent",
                                                border: answer[choice.option.stateKey].includes(option.stateKey ?? option.value) ? "2px solid rgb(255, 192, 0)" : "2px solid transparent",
                                                margin: "1px",
                                                fontSize: "30px",
                                                textAlign: "left",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {handleChoiceClick(option, choice.option.stateKey)}}    
                                        >{option.value}</Tag>
                                        </React.Fragment>
                                        
                                    )
                                })}
                            </Box>
                            <Box sx={{
                                position: "relative",
                                width: "100%",
                                display: "flex",
                                boxSizing: "border-box",
                            }}>
                                <p style={{
                                    fontStyle: "italic",
                                    fontWeight: "normal",
                                    marginTop: "3px",
                                    fontSize: "30px",
                                    textAlign: "left",
                                }}>{choice.question}</p>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ))}

            <Box component="img" 
                src={`${imagesResources}${data.image}`} 
                alt="Img"
                sx={{
                    marginLeft: "auto",
                    display: "block",
                }}
            />
        </Box>
    );
};